import { compressImage, getBase64Size, formatBytes } from './imageCompression';
import { toast } from '@/hooks/use-toast';

interface UploadOptions {
  maxWidth?: number;
  quality?: number;
  showFeedback?: boolean;
}

/**
 * Processa upload de imagem com compressão automática
 * @param file - Arquivo de imagem a ser processado
 * @param onSuccess - Callback com a imagem comprimida em base64
 * @param options - Opções de compressão (maxWidth, quality, showFeedback)
 */
export async function handleImageUploadWithCompression(
  file: File,
  onSuccess: (compressedBase64: string) => void,
  options: UploadOptions = {}
): Promise<void> {
  const { maxWidth = 400, quality = 0.7, showFeedback = true } = options;
  
  const reader = new FileReader();
  reader.onloadend = async () => {
    const original = reader.result as string;
    const originalSize = getBase64Size(original);
    
    try {
      const compressed = await compressImage(original, maxWidth, quality);
      const compressedSize = getBase64Size(compressed);
      const savings = Math.round((1 - compressedSize / originalSize) * 100);
      
      if (showFeedback && savings > 10) {
        toast({
          title: '📦 Imagem otimizada',
          description: `${formatBytes(originalSize)} → ${formatBytes(compressedSize)} (-${savings}%)`,
          duration: 2000,
        });
      }
      
      onSuccess(compressed);
    } catch (error) {
      console.error('Erro ao comprimir imagem:', error);
      // Fallback: usar imagem original se compressão falhar
      onSuccess(original);
    }
  };
  
  reader.readAsDataURL(file);
}
